export default "__VITE_ASSET__o9ysiMaBjQ$BkfDLwPz2mg__"